// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1gsNK","info":"PatientInfo_info__10nT3"};